import { useCallback } from 'react'
import useFeature, { features } from '@/hooks/useFeature'
import { LISTING_PATH, listingPathFor } from '@/pages/Submittals/listing-config'

/**
 * The listing URL that lands on a data element's own view, or the bare listing
 * when there is nothing to land on.
 *
 * The sibling `useListingTabState` carries the same intent as router state: a
 * row click hands the detail page the element it came from, so the sidebar can
 * keep that element highlighted before the submittal has loaded. This one is
 * for the other direction — the navigations that *arrive* at the listing, which
 * today is only the detail page's back controls. Since the tabs moved to the
 * sidebar the selected element is the URL, so those have to name it in the path;
 * router state would leave the address bar and the sidebar highlight pointing at
 * different elements.
 *
 * Gated on SUBMITTALS_PHASE_2 because `/submittals/de/:dataElementId` is only
 * routed behind it — with the flag off this is `/submittals`, exactly the path
 * these call sites used before.
 */
const useListingTabPath = () => {
  const isPhase2 = useFeature(features.SUBMITTALS_PHASE_2)

  return useCallback(
    dataElementId => (isPhase2 ? listingPathFor(dataElementId) : LISTING_PATH),
    [isPhase2]
  )
}

export default useListingTabPath
